<template>
    <b-dropdown
            v-if="showDropDown"
            id="kt_header_user_menu_toggle"
            variant="background-white"
            class="d-flex align-items-center ms-3 ms-lg-4 mr-0"
            menu-class="pl-0"
          >
            <template #button-content>
              <div
                class="btn btn-icon btn-color-gray-700 btn-active-color-primary btn-outline btn-outline-secondary w-30px h-30px w-lg-40px h-lg-40px"
                data-kt-menu-trigger="click"
                data-kt-menu-attach="parent"
                data-kt-menu-placement="bottom-end"
              >
                <!--begin::Svg Icon | path: icons/duotune/communication/com013.svg-->
                <span class="svg-icon svg-icon-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M6.28548 15.0861C7.34369 13.1814 9.35142 12 11.5304 12H12.4696C14.6486 12 16.6563 13.1814 17.7145 15.0861L19.3493 18.0287C20.0899 19.3618 19.1259 21 17.601 21H6.39903C4.87406 21 3.91012 19.3618 4.65071 18.0287L6.28548 15.0861Z"
                      fill="black"
                    />
                    <rect
                      opacity="0.3"
                      x="8"
                      y="3"
                      width="8"
                      height="8"
                      rx="4"
                      fill="black"
                    />
                  </svg>
                </span>
                <!--end::Svg Icon-->
              </div>
              {{ userFullName }}
            </template>
            <b-dropdown-item disabled v-if="isCustomer">
              <template #default>
                PYB#{{customerPYBNumber}}
              </template>
            </b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item v-if="isCustomer" @click="reRouteTo('MyBarrels')">
              <template #default>
                My Barrels
              </template>
            </b-dropdown-item>
            <b-dropdown-item v-if="isStaff" @click="reRouteTo('Admin')">
              <template #default>
                Manage Barrels
              </template>
            </b-dropdown-item>
            <b-dropdown-item @click="reRouteTo('Logout')">
              <template #default>
                Logout
              </template>
            </b-dropdown-item>
          </b-dropdown>
</template>

<script>
import mixins from "vue-typed-mixins";
import UserMixin from "@/mixins/UserMixin";
import ScreenMixin from "@/mixins/ScreenMixin";

export default mixins(ScreenMixin, UserMixin).extend({
    props: {
        hideUserDropdownBtn: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        showDropDown() {
            return this.signedIn && !this.hideUserDropdownBtn;
        }
    },
    methods: {
        reRouteTo(route){
            this.$router.push({name: route})
        },
    },
    });
</script>

<style lang="scss" scoped>

</style>